/**
 * ============================================================================
 *                              crmss 版权声明
 * ============================================================================
 * 本软件系统（crmss - 快速开发通用管理后台框架）所有代码版权归 crmss 团队所有。
 * 代码中的 crmss 版权声明不允许删除和修改。
 * ============================================================================
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import 'nprogress/nprogress.css'

import App from './App.vue'
import router from './router'

// crmss 全局样式
import '@/styles/index.scss'

// crmss 版权信息
const CRMSS_INFO = {
  name: '睿美经营宝品牌管理',
  version: '1.0.0',
  copyright: 'crmss Team',
  license: 'MIT'
}

// 打印 crmss 版权信息
console.log(
  `%c ${CRMSS_INFO.name} %c v${CRMSS_INFO.version} `,
  'background: #409EFF; color: #fff; padding: 4px 8px; border-radius: 4px 0 0 4px;',
  'background: #67C23A; color: #fff; padding: 4px 8px; border-radius: 0 4px 4px 0;'
)
console.log(`%c Copyright © ${new Date().getFullYear()} ${CRMSS_INFO.copyright}`, 'color: #909399;')

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// crmss 全局属性
app.config.globalProperties.$crmss = CRMSS_INFO

app.mount('#app')
